module.exports = __webpack_public_path__ + "img/测评2.2c026542.png";